import * as React from 'react';
import { Flex } from '../../../../../components/common/flex';
import { IPaymentInfoProps } from './payment_info.d';

export const PaymentInfo: React.FC<IPaymentInfoProps> = ({ paymentInfo }) => {
  return (
    <Flex vertical className={'approve-book-section'}>
      <div className={'price-summary'}>
        <div className={'price-summary__item'}>
          <Flex vertical align={'start'} className={'item-row'}>
            <div className={'item-row__title'}>Стоимость</div>
            <div className={'item-row__text typography-medium-3'}>{paymentInfo.result_cost}</div>
          </Flex>
        </div>
        <div className={'price-summary__item price-summary__item--grey'}>
          <Flex vertical align={'start'} className={'item-row'}>
            <div className={'item-row__title'}>Комиссия · {paymentInfo.commission_percent}%</div>
            <div className={'item-row__text typography-medium-3'}>{paymentInfo.commission}</div>
          </Flex>
        </div>
        <div className={'price-summary__item'}>
          <Flex vertical align={'start'} className={'item-row'}>
            <div className={'item-row__title'}>
              Предоплата {paymentInfo.prepayment_percent != null && `(${paymentInfo.prepayment_percent}%)`}
            </div>
            <div className={'item-row__text typography-medium-3'}>{paymentInfo.prepayment}</div>
          </Flex>
        </div>
        <div className={'price-summary__item'}>
          <Flex vertical align={'start'} className={'item-row'}>
            <div className={'item-row__title'}>К оплате при заселении</div>
            <div className={'item-row__text typography-medium-3'}>{paymentInfo.payment_on_camp}</div>
          </Flex>
        </div>
      </div>
    </Flex>
  );
};
